// source: https://stackoverflow.com/a/52171480
export function generateColorHashFromString(s: string): string {
    let i = 0,
        h = 9;
    while (i < s.length) {
        h = Math.imul(h ^ s.charCodeAt(i++), 9 ** 9);
    }
    return (Math.abs(h ^ (h >>> 9)) % Math.pow(2, 24)).toString(16).padStart(6, '0');
}
